import React, { useState, useEffect } from 'react';
import { useSupplierCategoryQuery, useSupplierListQuery } from '../../Store/Apis/supplierApis';
import { useOutletsQuery } from '../../Store/Apis/outletApi';
import { isDropdownPermission } from '../../Hooks/permissionsMiddleware';
import { useSelector } from 'react-redux';

const AddEditSupplierProduct = ({ handleSubmit, data }) => {
    const user = useSelector((state) => state.auth.user);
    const getOutletApi = useOutletsQuery();
    const [sortFilter, setSortFilter] = useState({
        outletID: ''
    });
    const getSuppliersCategoryApi = useSupplierCategoryQuery({
        outletID: sortFilter.outletID
    })
    const getSuppliersApi = useSupplierListQuery({
        outletID: sortFilter.outletID
    })
    const [form, setForm] = useState({
        outletId: '',
        supplierId: '',
        categoryId: '',
        productName: ''
    });
    const [errors, setErrors] = useState({});

    // Populate form if data prop is passed (edit mode)
    useEffect(() => {
        if (data) {
            setForm({
                outletId: data.outletId || '',
                supplierId: data.supplierId || '',
                categoryId: data.categoryId || '',
                productName: data.productName || ''
            });
        }
    }, [data]);

    const validate = () => {
        const newErrors = {};
        if (!form.outletId) newErrors.outletId = 'Outlet is required';
        if (!form.supplierId) newErrors.supplierId = 'Supplier Name is required';
        if (!form.categoryId) newErrors.categoryId = 'Category is required';
        if (!form.productName) newErrors.productName = 'Product Name is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            handleSubmit(form);  // Pass form data to parent component
        }
    };


    useEffect(() => {
        if(!isDropdownPermission(user.role_Id) && !data){
          setForm({
            ...form,
            outletId: user.outletID
          })
        }
    }, [])

    useEffect(() => {
        if (user.role !== 'superAdmin') {
            setSortFilter({
                outletID: user.outletID
            });
        }
    }, []);
    

    return (
        <form onSubmit={handleFormSubmit} noValidate>
            <div className="row">
                <div className="col-md-6 mb-3">
                    <label>Outlet <span className="text-danger">*</span></label>
                    <select
                        name="outletId"
                        className={`form-select ${errors.outletId ? 'is-invalid' : ''}`}
                        value={form.outletId}
                        onChange={handleChange}
                        disabled={!getOutletApi.isSuccess || !isDropdownPermission(user.role_Id)}
                    >
                        <option value="">Select Outlet</option>
                        {getOutletApi?.data?.data?.map((outlet, i) => (
                            <option key={i} value={outlet.outletId}>
                                {outlet.outletName}
                            </option>
                        ))}
                    </select>
                    {errors.outletId && <small className="text-danger">{errors.outletId}</small>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Supplier <span className="text-danger">*</span></label>
                    <select
                        name="supplierId"
                        className={`form-control ${errors.supplierId ? 'is-invalid' : ''}`}
                        value={form.supplierId}
                        onChange={handleChange}
                    >
                        <option value="">Select Supplier</option>
                        {getSuppliersApi?.data?.data?.map((supplier, i) => (
                            <option key={i} value={supplier.id}>
                                {supplier.companyName}
                            </option>
                        ))}
                    </select>
                    {errors.supplierId && <small className="text-danger">{errors.supplierId}</small>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Category Name <span className="text-danger">*</span></label>
                    <select
                        name="categoryId"
                        className={`form-control ${errors.categoryId ? 'is-invalid' : ''}`}
                        value={form.categoryId}
                        onChange={handleChange}
                        disabled={!getSuppliersCategoryApi.isSuccess}
                    >
                        <option value="">Select Product Category</option>
                        {getSuppliersCategoryApi?.data?.data.map((category, i) => (
                            <option key={i} value={category.id}>
                                {category.categoryName}
                            </option>
                        ))}
                    </select>
                    {errors.categoryId && <small className="text-danger">{errors.categoryId}</small>}
                </div>

                <div className="col-md-6 mb-3">
                    <label>Product Name <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        name="productName"
                        className={`form-control ${errors.productName ? 'is-invalid' : ''}`}
                        value={form.productName}
                        onChange={handleChange}
                        placeholder="Enter Product Name"
                    />
                    {errors.productName && <small className="text-danger">{errors.productName}</small>}
                </div>
            </div>
            <div className="d-flex justify-content-center">
                <button type="submit" className="btn btn-primary">Submit</button>
            </div>
        </form>
    );
};

export default AddEditSupplierProduct;
